export const CONSULTATION_DURATION_MINUTES = 50
